import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Space+Grotesk:wght@400;500;600;700&display=swap');

  :root {
    --fibre-yellow: #F5B800;
    --data-black: #0E1114;
    --steel-grey: #2C2F33;
    --fibre-red: #D62828;
    --network-blue: #0077B6;
    --optical-green: #2EC4B6;
    --bg-grey: #F2F4F7;
    --bg-primary: #FFFFFF;
    --bg-secondary: #F2F4F7;
    --text-primary: #0E1114;
    --text-secondary: #2C2F33;
    --card-bg: #FFFFFF;
  }

  [data-theme="dark"] {
    --bg-grey: #0E1114;
    --bg-primary: #1a1d21;
    --bg-secondary: #0E1114;
    --text-primary: #F2F4F7;
    --text-secondary: #D1D5DB;
    --card-bg: #2C2F33;
    --steel-grey: #3a3d41;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    line-height: 1.7;
    color: var(--text-primary);
    background: var(--bg-secondary);
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', sans-serif;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1.5rem;
    letter-spacing: -0.5px;
    color: var(--text-primary);
  }

  h1 {
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    font-weight: 800;
  }

  h2 {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
  }

  h3 {
    font-size: clamp(1.5rem, 3vw, 2.5rem);
  }

  p {
    margin-bottom: 1.5rem;
    font-size: 1.05rem;
    line-height: 1.8;
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  button {
    cursor: pointer;
    font-family: inherit;
    border: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  ::selection {
    background: var(--fibre-yellow);
    color: var(--data-black);
  }

  ::-webkit-scrollbar {
    width: 14px;
  }

  ::-webkit-scrollbar-track {
    background: var(--steel-grey);
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, var(--fibre-yellow) 0%, var(--optical-green) 100%);
    border-radius: 7px;
    border: 2px solid var(--steel-grey);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--fibre-yellow);
  }
`;

export default GlobalStyles;
